import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';


import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';

// Import controller service
import { ControllerService } from './services/controller/controller.service';

// Import environment variables
import { environment } from '../environments/environment';


import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';



@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    // App router
    RouterOutlet,
    // Custom components
    HeaderComponent,
    FooterComponent,
    // Angular material
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {

  title = environment.appName;
  
  constructor(
    public controllerService:ControllerService,
  ){}

  ngOnInit() {
    this.controllerService.initializeApp();
  }

  openSettings(){
    this.controllerService.openCookiesPopup()
  }


}
